module.exports = __webpack_public_path__ + "static/caffenio-02ca08a063d523957d0db310a92d9518.webp";